import {Component, OnInit, Renderer2, ViewChild} from '@angular/core';
import {
  barChartData,
  barChartLabels,
  barChartOptions,
  barChartType,
  EQ5D5LResults,
  Q_EQ_5D_5L
} from '../../../../model/questionnaires/questionnaire-eq5d5l';
import {FormGroup} from '@angular/forms';
import {QuestionnaireService} from '../../../../services/questionnaire.service';
import {MatDialog} from '@angular/material/dialog';
import {ErrorDialogComponent} from '../../../user-actions/error-dialog/error-dialog.component';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-questionnaire-eq5d5l',
  templateUrl: './questionnaire-eq5d5l.component.html',
  styleUrls: ['./questionnaire-eq5d5l.component.css']
})
export class QuestionnaireEq5d5lComponent implements OnInit {

  qForm: FormGroup;
  notFocused = false;
  source = Q_EQ_5D_5L;
  results = [];
  submitted = false;
  show = false;
  currentCheckedValue = [null];
  found = false;

  /// toolbar
  back = true;
  destination = '/questionnaires';
  title = 'EQ5D5L';
  user = null;
  uuid = null;
  authorization: boolean;
  doctorID: string;
  patientSSN: string;
  sliderValue = 0;

  constructor(private questionnaireService: QuestionnaireService,
              private ren: Renderer2,
              public dialog: MatDialog,
              private route: ActivatedRoute,
              private router: Router) { }

  ngOnInit(): void {
    this.qForm = new FormGroup({
      // health: new FormControl('', [Validators.required, Validators.min(0), Validators.max(100)])
    });

    this.user = JSON.parse(localStorage.getItem('user'));
    this.route.params.subscribe(params => {
      this.doctorID = params.doctorID;
      this.patientSSN = params.patientSSN;
      this.uuid = params.uuid;
      this.authorization = this.user.ssn.localeCompare(params.patientSSN) === 0;
      if (params.back.localeCompare('questionnaires') === 0) {
        this.destination = 'questionnaires';
      } else if (params.back.localeCompare('choose-questionnaire') === 0) {
        this.destination = 'choose-questionnaire';
      }
    });
  }

  onSubmit() {
    this.submitted = true;
    this.show = true;
    this.found = false;

    console.log(this.results);
    if (this.results.length !== this.source.length) {
        const msg = 'Non hai finito di completare il questionario!';
        this.openDialog(msg);
        this.show = false;
        this.submitted = false;
      } else {
        for (const r of this.results) {
          if (r === null) {
            const msg = 'Non hai finito di completare il questionario!';
            this.openDialog(msg);
            this.show = false;
            this.submitted = false;
            this.found = true;
            break;
          }
        }

        if (!this.found) {
          console.log(this.doctorID + ' ' + this.patientSSN + ' ' + this.results + ' ' + this.sliderValue);
          const resultToSend = new EQ5D5LResults(this.doctorID, this.patientSSN, this.results, this.sliderValue);
          this.questionnaireService.sendForm(resultToSend, 'eq5d5l', this.uuid);
        }
      }

  }

  openDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '270px',
      data: message
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Finestra chiusa');
    });
  }

  setAnswer(answer: string, position: number) {
    this.results[position - 1] = answer;
    console.log(this.results);
  }

  checkState(el, position: number) {
    setTimeout(() => {
      if (this.currentCheckedValue[position - 1] && this.currentCheckedValue[position - 1] === el.value) {
        el.checked = false;
        this.ren.removeClass(el._elementRef.nativeElement, 'cdk-focused');
        this.ren.removeClass(el._elementRef.nativeElement, 'cdk-program-focused');
        this.currentCheckedValue[position - 1] = null;
        this.results[position - 1] = null;
      } else {
        this.currentCheckedValue[position - 1] = el.value;
      }
    });
  }

  goHome() {
    if (this.user === null) {
      this.router.navigateByUrl('/startup');
    } else {
      this.router.navigateByUrl('/landing');
    }
  }

  setHealth() {
    console.log(this.sliderValue);
  }
}
